// extracted by mini-css-extract-plugin
export default {"CreateJobSubCategory":"create-job-sub-category_CreateJobSubCategory__NR5DM"};